import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: number;
  message: string;
  type: 'danger' | 'success' | 'warning';
}

@Injectable({ providedIn: 'root' })
export class NewToastService {
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  toasts$ = this.toastsSubject.asObservable();

  private nextId = 0;

  show(message: string, type: 'danger' | 'success' | 'warning', time: number) {
    const current = this.toastsSubject.value;

    const limited = current.length >= 3 ? current.slice(1) : current;

    const toast: Toast = { id: this.nextId++, message, type };
    this.toastsSubject.next([...limited, toast]);

    setTimeout(() => this.dismiss(toast.id), time);
  }

  dismiss(id: number) {
    this.toastsSubject.next(this.toastsSubject.value.filter((t) => t.id !== id));
  }
}
